import { h, Component } from 'preact';

import style from '../../style/loading.sass';

export default class Loading extends Component {
  render(props) {
    let primaryElementBorderStyle = style.primaryBubbleBorderRheem;
    let primaryElementStyle = style.primaryBubbleRheem;
    let satelliteElementBorderStyle = style.satelliteBubbleBorderRheem;
    let satelliteElementStyle = style.satelliteBubbleRheem;
    const containerStyles = [style.container];

    if(props.brand === 'ruud'){
      primaryElementBorderStyle = style.primaryHexBorderRuud;
      primaryElementStyle = style.primaryHexRuud;
      satelliteElementBorderStyle = style.satelliteHexBorderRuud;
      satelliteElementStyle = style.satelliteHexRuud;
      containerStyles.push(style.containerRuud);
    }

    if(props.brand === 'friedrich'){
      primaryElementBorderStyle = style.primaryShieldBorderFriedrich;
      primaryElementStyle = style.primaryShieldFriedrich;
      satelliteElementBorderStyle = style.satelliteShieldBorderFriedrich;
      satelliteElementStyle = style.satelliteShieldFriedrich;
      containerStyles.push(style.containerFriedrich);
    }

    return (
      <div className={containerStyles.join(' ')}>
        <div className={primaryElementBorderStyle}></div>
        <div className={primaryElementStyle}>
          <span className={style.message}>
            LOADING
          </span>
        </div>
        <div className={satelliteElementBorderStyle}></div>
        <div className={satelliteElementStyle}></div>
      </div>
    );
  }
}